import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { dashboard } from './dashboard/RS';
import { overview } from './overview/RS';
import { productInfoBox } from './productInfoBox/RS';

export const leasing: LeasingFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: false,
    dashboard,
    overview,
    productInfoBox,
};
